// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-body[data-v-13df3591]{min-width:340px;border-radius:10px;background-color:#fff;padding:40px 60px}", ""]);
// Exports
module.exports = exports;
